import { useState } from 'react';
import classNames from 'classnames';

import { Close, IconSvg, Portal } from '@/components';

import type { OrderFilterType } from './constants';
import {
  ORDER_FILTER_LABELS,
  ORDER_FILTER_MOBILE_LABELS,
  ORDER_FILTER_OPTIONS,
} from './constants';

type OrdersFilterBarProps = {
  orderFilter: OrderFilterType;
  onOrderFilterChange: (_: OrderFilterType) => void;
};

const OrdersFilterBar = ({
  orderFilter,
  onOrderFilterChange,
}: OrdersFilterBarProps) => {
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);

  const handleMobileSelect = (filter: OrderFilterType) => {
    onOrderFilterChange(filter);
    setIsMobileModalOpen(false);
  };

  return (
    <>
      <div className="orders__filter-bar">
        <ul
          aria-label="Order filter"
          className="orders__filter-bar__buttons"
          role="tablist"
        >
          {ORDER_FILTER_OPTIONS.map(filterOption => (
            <li
              aria-selected={orderFilter === filterOption}
              className={classNames('orders__filter-bar__btn', {
                'orders__filter-bar__btn--active': orderFilter === filterOption,
              })}
              key={filterOption}
              onClick={() => onOrderFilterChange(filterOption)}
              role="tab"
            >
              {ORDER_FILTER_LABELS[filterOption]}
            </li>
          ))}
        </ul>
        <button
          aria-expanded={isMobileModalOpen}
          aria-haspopup="dialog"
          aria-label="Filter orders"
          className="orders__filter-bar__mobile-trigger"
          onClick={() => setIsMobileModalOpen(true)}
          type="button"
        >
          <IconSvg decorative={false} name="simple-filter" />
          <span className="orders__filter-bar__mobile-trigger-label">
            {ORDER_FILTER_MOBILE_LABELS[orderFilter]}
          </span>
        </button>
      </div>

      <Portal
        activeSnapPoint={1}
        classContent="orders__filter-drawer"
        direction="bottom"
        isOpen={isMobileModalOpen}
        showIconTouch={false}
        snapPoints={[1]}
        toggle={() => setIsMobileModalOpen(false)}
      >
        <div className="orders__filter-drawer__inner">
          <div className="orders__filter-drawer__header">
            <p className="orders__filter-drawer__title">Filter orders</p>
            <Close onClick={() => setIsMobileModalOpen(false)} />
          </div>
          <div
            aria-label="Order filter"
            className="orders__filter-modal"
            role="radiogroup"
          >
            {ORDER_FILTER_OPTIONS.map(filterOption => (
              <label
                className="orders__filter-modal__option"
                htmlFor={`orders-filter-${filterOption}`}
                key={filterOption}
              >
                <input
                  checked={orderFilter === filterOption}
                  className="orders__filter-modal__radio"
                  id={`orders-filter-${filterOption}`}
                  name="orders-filter"
                  onChange={() => handleMobileSelect(filterOption)}
                  type="radio"
                  value={filterOption}
                />
                <span className="orders__filter-modal__label">
                  {ORDER_FILTER_LABELS[filterOption]}
                </span>
              </label>
            ))}
          </div>
        </div>
      </Portal>
    </>
  );
};

export { OrdersFilterBar };
